import cn from 'classnames';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { BIGEDIRECT_WIDGET_BASE_URL } from 'constants/environment';

import { Spinner } from '@atoms/Spinner/Spinner';

type Props = {
  token: string;
  className?: string;
};

export const BigedirectCryptoIframe = ({ token, className }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const timeoutRef = useRef<number>();
  const [isReady, setIsReady] = useState(false);

  const sendToken = useCallback(() => {
    if (!iframeRef.current?.contentWindow) return;
    iframeRef.current.contentWindow.postMessage(
      { accessToken: token },
      BIGEDIRECT_WIDGET_BASE_URL
    );
    setIsReady(true);
  }, [token]);

  const url = useMemo(() => {
    return `${BIGEDIRECT_WIDGET_BASE_URL}/widget`;
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== BIGEDIRECT_WIDGET_BASE_URL) return;
      if (event.source !== iframeRef.current?.contentWindow) return;

      if (event.data?.type === 'widget-ready') {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(sendToken, 1000);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      clearTimeout(timeoutRef.current);
    };
  }, [sendToken]);

  return (
    <div className={cn('relative h-[45rem] w-full', className)}>
      {!isReady && <Spinner />}
      <iframe
        ref={iframeRef}
        src={url}
        allow="clipboard-write"
        className={cn('h-full w-full', !isReady && 'invisible')}
        title="Bigedirect crypto widget"
      />
    </div>
  );
};
